import React from 'react';
import { LineChart } from '@carbon/charts-react';
import PropTypes from 'prop-types';
import { toolbarOptions } from "./utils";

const LineGraph = ({
  height        = "100%",
  title         = "Bar Chart Graph",
  yAxisTitle    = "",
  xAxisTitle    = "",
  showXTicks    = true,   // ← false para ocultar labels del eje X
  lineData      = [
    { group: 'Dataset 1', key: 'Qty',        value: 34200 },
    { group: 'Dataset 1', key: 'More',       value: 23500 },
    { group: 'Dataset 1', key: 'Sold',       value: 53100 },
    { group: 'Dataset 1', key: 'Restocking', value: 42300 },
    { group: 'Dataset 1', key: 'Misc',       value: 12300 },
  ]
}) => {
  const options = {
    title: `${title}`,
    axes: {
      bottom: {
        title      : xAxisTitle,
        mapsTo     : 'key',
        scaleType  : 'labels',
        ticks      : showXTicks ? {} : { values: [] },
      },
      left: {
        mapsTo   : 'value',
        title    : yAxisTitle,
        scaleType: 'linear',
      }
    },
    height: `${height}`,
    width : "95%",
    theme : "g100",
    points: { enabled: false },
    color : {
      scale: { 'Dataset 1': '#D12771' }
    },
    ...toolbarOptions
  };

  return <LineChart data={lineData} options={options} />;
};

LineGraph.propTypes = {
  height    : PropTypes.string,
  title     : PropTypes.string,
  xAxisTitle: PropTypes.string,
  yAxisTitle: PropTypes.string,
  showXTicks: PropTypes.bool,
  lineData  : PropTypes.array,
};

export default LineGraph;